import { api } from '@/api/client';
import type { SuperadminTransactionApiResponse, SuperadminTransactionStats } from '../pages/transactions/types';

// Superadmin Transactions Service
export const superadminTransactionsService = {
  /**
   * Get transactions list with pagination and filters
   */
  async list(
    page: number = 1,
    pageSize: number = 15,
    filters?: {
      transaction_id?: string;
      merchant_transaction_id?: string;
      transaction_status?: string;
      start_date?: string;
      end_date?: string;
      documentUrl: string;
      merchant_uuid?: string;
    }
  ): Promise<SuperadminTransactionApiResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });

    // Add filters if provided
    if (filters?.transaction_id && filters.transaction_id.trim()) {
      params.append('transaction_id', filters.transaction_id.trim());
    }

    if (filters?.merchant_transaction_id && filters.merchant_transaction_id.trim()) {
      params.append('merchant_transaction_id', filters.merchant_transaction_id.trim());
    }

    if (filters?.transaction_status && filters.transaction_status.trim()) {
      params.append('transaction_status', filters.transaction_status.trim());
    }

    if (filters?.start_date && filters.start_date.trim()) {
      params.append('start_date', filters.start_date.trim());
    }

    if (filters?.end_date && filters.end_date.trim()) {
      params.append('end_date', filters.end_date.trim());
    }

    if (filters?.merchant_uuid) {
    params.append('merchant_uuid', filters.merchant_uuid);
  }

    const response = await api.get<SuperadminTransactionApiResponse>(`/backoffice/api/v1/transactions/?${params.toString()}`);
    return response as unknown as SuperadminTransactionApiResponse;
  },


  

  /**
   * Get transaction by ID
   */
  async getById(transactionId: string): Promise<SuperadminTransactionApiResponse> {
    const response = await api.get<SuperadminTransactionApiResponse>(`/backoffice/api/v1/transactions/${transactionId}/`);
    return response as unknown as SuperadminTransactionApiResponse;
  },
  


 async stats(): Promise<SuperadminTransactionStats> {
  const response = await api.get<SuperadminTransactionStats>(
    '/backoffice/api/v1/transactions-stats/'
  );
  return response as unknown as SuperadminTransactionStats;
},


 async listMerchants() {
    return api.get('/backoffice/api/v1/merchants/');
  },





};
